import { DataLayer } from "@sazka/utils/data-layer";
import { useLocalStorage } from "@sazka/utils/use-storage";
import {
    ActiveFrontendAbTests,
    AbTestSelectedVariant,
    abTestsStorageName,
    useDefaultAbTestAnalytics,
} from "../ab-test";

export namespace AbTestAnalytics {
    const store = useLocalStorage();

    const getFrontendAbTests = () => {
        let tests = store.getJson<AbTestSelectedVariant[]>(abTestsStorageName);
        if (!tests) {
            return [];
        }

        //remove inactive ab tests
        tests = tests.filter(
            (t) => Object.values(ActiveFrontendAbTests).includes(t.testId) && useDefaultAbTestAnalytics(t.testId)
        );
        store.setJson(abTestsStorageName, tests, "essential");

        return tests;
    };

    const getBackendAbTests = () => {
        const tests = window.abTests;
        if (!tests) {
            return [];
        }

        return tests;
    };

    export const pushAbTest = () => {
        const abTests = getFrontendAbTests().concat(getBackendAbTests());

        if (abTests) {
            DataLayer.push({ session: { ABTests: abTests } });
        }
    };
}
